// extracted by mini-css-extract-plugin
export default {"question-section":"QuizQuestionHeading-module__question-section__uKSjg","question-section-subcopy":"QuizQuestionHeading-module__question-section-subcopy__euRT3"};